const CREATE = 'Crear'
const SHOW = 'Ver'
const EDIT = 'Editar'
const GENERATE = 'Generar'

export {
  CREATE,
  SHOW,
  EDIT,
  GENERATE,
}